import SageScreen from "kit/SageScreen";
import React from "react";
import classnames from "classnames";
import stringDollarToCentHundredths from "utils/stringDollarToCentHundredths";
import { useDispatch, useSelector } from "react-redux";
import SageButton from "kit/SageButton";
import { createAddMoney, setCreateAddMoneyStatus } from "actions/balance";
import addMoneyStatusSelector from "selectors/addMoneyStatus";
import SageErrorAlert from "kit/SageErrorAlert";

const BalanceMoneyAdd: React.FC = () => {
    const dispatch = useDispatch();
    const [value, setValue] = React.useState("");
    const [isInvalid, setIsInvalid] = React.useState(false);
    const status = useSelector(addMoneyStatusSelector);

    const onInputChange = React.useCallback(
        (e: React.ChangeEvent<HTMLInputElement>) => {
            setValue(e.target.value);
        },
        [setValue]
    );

    const handleSubmit = React.useCallback(
        (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            const centHundredths = stringDollarToCentHundredths(value);
            if (isNaN(centHundredths)) {
                setIsInvalid(true);
                return;
            }
            setIsInvalid(false);
            dispatch(createAddMoney(centHundredths));
        },
        [value, dispatch]
    );

    const onErrorDismiss = React.useCallback(() => {
        dispatch(setCreateAddMoneyStatus("none"));
    }, [dispatch]);

    return (
        <SageScreen>
            <h2>Add Money</h2>
            <p>Add money to your account so that you can buy minutes.</p>
            <form onSubmit={handleSubmit}>
                <div className="input-group mb-2">
                    <div className="input-group-prepend">
                        <div className="input-group-text">$</div>
                    </div>
                    <input
                        onChange={onInputChange}
                        value={value}
                        type="text"
                        id="money"
                        className={classnames(
                            "form-control",
                            isInvalid && "is-invalid"
                        )}
                    />
                    <div className="invalid-feedback">
                        Please input the amount that you would like to transfer
                        in the form 54.23 (maximum two decimal points)
                    </div>
                </div>
                <SageButton
                    loading={status === "loading"}
                    type="submit"
                    text="Add Money"
                />
            </form>
            {status === "error" && (
                <SageErrorAlert
                    text="An error occurred. Please try again."
                    onDismiss={onErrorDismiss}
                />
            )}
        </SageScreen>
    );
};

export default BalanceMoneyAdd;
